import { createSelector } from 'reselect';

const key = 'promocode';
const domains = {
    value: (state) => state.global[key].value,
    isLoading: (state) => state.global[key].isLoading,
    name: (state) => state.global[key].name,
    modalIsVisible: (state) => state.global[key].modalIsVisible,
};

const selectorValue = createSelector([domains.value], (value) => value);

const selectorIsLoading = createSelector([domains.isLoading], (isLoading) => isLoading);

const selectorName = createSelector([domains.name], (name) => name);

const selectorModalIsVisible = createSelector(
    [domains.modalIsVisible],
    (modalIsVisible) => modalIsVisible
);

const makeSelectValue = () => selectorValue;
const makeSelectIsLoading = () => selectorIsLoading;
const makeSelectName = () => selectorName;
const makeSelectModalIsVisible = () => selectorModalIsVisible;

export { makeSelectValue, makeSelectIsLoading, makeSelectName, makeSelectModalIsVisible };
